<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-body">
        <h4>ادارة سيرفرات الأجهزة (الحد الأقصى والأولوية)</h4>
        <p class="text-muted">
          الترتيب من الأعلى للأسفل هو ترتيب الأولوية في توزيع الأجهزة الجديدة. السيرفر في أعلى القائمة يُملأ أولاً قبل الانتقال للذي يليه.
        </p>
        <div class="row">
          <div class="col-md-6">
            <button class="btn btn-primary" @click="openNew('main')">
              <i class="fa fa-plus"></i> اضافة سيرفر للمجموعة الأساسية
            </button>
          </div>
          <div class="col-md-6 text-end">
            <button class="btn btn-secondary" @click="openNew('real')">
              <i class="fa fa-plus"></i> اضافة سيرفر لمجموعة real_worker
            </button>
          </div>
        </div>
      </div>

      <div class="card card-body" v-for="group in ['main', 'real']" :key="group">
        <h5>
          {{ group == 'main' ? 'المجموعة الأساسية' : 'مجموعة real_worker' }}
        </h5>
        <div v-if="loading">جاري التحميل...</div>
        <table class="table table-bordered table-hover" v-else>
          <thead>
            <th style="width:60px">الترتيب</th>
            <th>السيرفر</th>
            <th>الحد الأقصى</th>
            <th>الاستخدام الحالي</th>
            <th>نسبة الامتلاء</th>
            <th>الحالة</th>
            <th style="width:200px">خيارات</th>
          </thead>
          <tbody>
            <tr v-for="(l, i) in groupLimits(group)" :key="l._id">
              <td>
                <button class="btn btn-sm btn-light" :disabled="i==0" @click="move(group, i, -1)">
                  <i class="fa fa-arrow-up"></i>
                </button>
                <button class="btn btn-sm btn-light" :disabled="i==groupLimits(group).length-1" @click="move(group, i, 1)">
                  <i class="fa fa-arrow-down"></i>
                </button>
              </td>
              <td>Worker #{{ l.worker_id }}</td>
              <td>{{ l.max }}</td>
              <td>{{ counts[l.worker_id] || 0 }}</td>
              <td>
                <div class="progress" style="height: 20px">
                  <div
                    class="progress-bar"
                    :class="barClass(counts[l.worker_id] || 0, l.max)"
                    :style="{ width: pct(counts[l.worker_id] || 0, l.max) + '%' }"
                  >
                    {{ pct(counts[l.worker_id] || 0, l.max) }}%
                  </div>
                </div>
              </td>
              <td>
                <span class="badge bg-success" v-if="l.enabled">مفعل</span>
                <span class="badge bg-danger" v-else>معطل</span>
              </td>
              <td>
                <button class="btn btn-sm btn-info" @click="openEdit(l)">
                  <i class="fa fa-edit"></i> تعديل
                </button>
                <button class="btn btn-sm btn-danger" @click="del(l._id)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!groupLimits(group).length">
              <td colspan="7" class="text-center text-muted">لا توجد سيرفرات</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal v-model="showModal" :title="editing._id ? 'تعديل سيرفر' : 'اضافة سيرفر'" hide-footer>
      <div class="form-group">
        <label>المجموعة</label>
        <select class="form-control" v-model="editing.group">
          <option value="main">الأساسية</option>
          <option value="real">real_worker</option>
        </select>
      </div>
      <div class="form-group">
        <label>رقم السيرفر (worker_id)</label>
        <input type="number" class="form-control" v-model="editing.worker_id" />
      </div>
      <div class="form-group">
        <label>الحد الأقصى للأجهزة</label>
        <input type="number" class="form-control" v-model="editing.max" />
      </div>
      <div class="form-group">
        <label>الأولوية (الأقل = الأول)</label>
        <input type="number" class="form-control" v-model="editing.priority" />
      </div>
      <div class="form-group">
        <label>
          <input type="checkbox" v-model="editing.enabled" /> مفعل
        </label>
      </div>
      <button class="btn btn-primary" @click="save()">حفظ</button>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
export default {
  components: { BModal },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      loading: true,
      limits: [],
      counts: {},
      showModal: false,
      editing: {},
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      var g = this;
      g.loading = true;
      $.post(api + "/admin/devices/limits/list", {
        jwt: g.user.jwt,
      }).then(function (r) {
        g.limits = r.response.limits;
        g.counts = r.response.counts;
        g.loading = false;
      });
    },
    groupLimits(group) {
      return this.limits.filter((l) => l.group == group);
    },
    pct(used, max) {
      if (!max) return 0;
      return Math.min(100, Math.round((used / max) * 100));
    },
    barClass(used, max) {
      var p = this.pct(used, max);
      if (p < 50) return "bg-success";
      if (p < 80) return "bg-warning";
      return "bg-danger";
    },
    openNew(group) {
      this.editing = {
        group: group,
        worker_id: "",
        max: 50,
        priority: this.groupLimits(group).length,
        enabled: true,
      };
      this.showModal = true;
    },
    openEdit(l) {
      this.editing = JSON.parse(JSON.stringify(l));
      this.showModal = true;
    },
    save() {
      var g = this;
      $.post(api + "/admin/devices/limits/save", {
        jwt: g.user.jwt,
        id: g.editing._id,
        worker_id: g.editing.worker_id,
        max: g.editing.max,
        priority: g.editing.priority,
        group: g.editing.group,
        enabled: g.editing.enabled,
      }).then(function () {
        g.showModal = false;
        g.load();
      });
    },
    del(id) {
      var g = this;
      if (!confirm("متأكد من الحذف؟")) return;
      $.post(api + "/admin/devices/limits/delete", {
        jwt: g.user.jwt,
        id: id,
      }).then(function () {
        g.load();
      });
    },
    move(group, index, delta) {
      var g = this;
      var arr = g.groupLimits(group);
      var target = index + delta;
      if (target < 0 || target >= arr.length) return;
      var moved = arr.splice(index, 1)[0];
      arr.splice(target, 0, moved);
      $.post(api + "/admin/devices/limits/reorder", {
        jwt: g.user.jwt,
        order: arr.map((x) => x._id),
      }).then(function () {
        g.load();
      });
    },
  },
};
</script>
